"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProgressBar = _interopRequireDefault(require("../ProgressBar"));
var _userflow = require("../../utils/userflow");
var _easing = _interopRequireDefault(require("./easing"));
var _PreloadImage = _interopRequireDefault(require("../PreloadImage"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 14.9L37 65l-21 50.1"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 130",
  fill: "none",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
};
/* load next batch when scrolled by 90% of current loaded images */
var PAGINATION_THRESHOLD = 90;
/* thumbnail to full image size multiplier, counted fixed height */
var COEFF = 300 / 40;
var ScrollCarousel = /*#__PURE__*/function (_React$PureComponent) {
  function ScrollCarousel(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ScrollCarousel);
    _this = _callSuper(this, ScrollCarousel, [props]);
    var paginationSize = props.paginationSize,
      items = props.items;
    _this.state = {
      hideControl: 'prev',
      imageLoadedCount: 0,
      thumbLoadedCount: 0,
      /* Preload batch of images or all images if not defined */
      preloadedItemsCount: Math.min(paginationSize || items.length, items.length)
    };

    // In case of SSR this shoud be placed in componentDidMount w/ rerender
    _this.events = (0, _userflow.makeTouchDependableEvents)();
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.scrollTo = _this.scrollTo.bind(_this);
    _this.scrollMouse = _this.scrollMouse.bind(_this);
    _this.handleImageLoad = _this.handleImageLoad.bind(_this);
    _this.handleThumbLoad = _this.handleThumbLoad.bind(_this);
    _this.onArrowClick = _this.onArrowClick.bind(_this);
    _this.renderImagesMapMemoized = (0, _memoize2["default"])(_this.renderImagesMap, function (imagesType, images) {
      return "".concat(imagesType).concat(images.length);
    });
    _this.topImagesRef = /*#__PURE__*/_react["default"].createRef();
    _this.bottomImagesRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  (0, _inherits2["default"])(ScrollCarousel, _React$PureComponent);
  return (0, _createClass2["default"])(ScrollCarousel, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.widthObserver();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.mounted = true;
      var thumbs = this.config.thumbs;
      this.topImages = this.topImagesRef.current;
      this.bottomImages = this.bottomImagesRef.current;
      var rendered = function rendered() {
        if (thumbs) {
          if (_this2.bottomImages) {
            return _this2.setState({
              ready: true
            });
          }
        } else if (_this2.topImages) {
          return _this2.setState({
            ready: true
          });
        }
        window.requestAnimationFrame(rendered);
        return null;
      };
      rendered();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.ready && !prevState.ready) {
        this.syncScroll(this.topImages, this.bottomImages);
      }
    }
  }, {
    key: "handleImageLoad",
    value: function handleImageLoad() {
      this.setState(function (_ref) {
        var imageLoadedCount = _ref.imageLoadedCount;
        return {
          imageLoadedCount: imageLoadedCount + 1
        };
      });
    }
  }, {
    key: "handleThumbLoad",
    value: function handleThumbLoad() {
      this.setState(function (_ref2) {
        var thumbLoadedCount = _ref2.thumbLoadedCount;
        return {
          thumbLoadedCount: thumbLoadedCount + 1
        };
      });
    }
  }, {
    key: "onArrowClick",
    value: function onArrowClick(e) {
      var _this3 = this;
      (0, _userflow.unlessLocked)(this, e, function () {
        var diff = e.currentTarget.dataset.direction;
        var width = _this3.containerRef.current.clientWidth * diff;
        _this3.diffScroll(_this3.topImages, width, _this3.bottomImages, true);
      });
    }
  }, {
    key: "onBottomImageClick",
    value: function onBottomImageClick(index, e) {
      var _this4 = this;
      this.preloadAllImages(function () {
        return (0, _userflow.unlessLocked)(_this4, e, function () {
          return _this4.scrollTo(index);
        });
      });
    }
  }, {
    key: "onTopImageClick",
    value: function onTopImageClick(origin, i, e) {
      var _this5 = this;
      (0, _userflow.unlessLocked)(this, e, function () {
        var onImageClick = _this5.props.onImageClick;
        onImageClick({
          index: i,
          item: origin
        });
      });
    }
  }, {
    key: "onOverlayDown",
    value: function onOverlayDown(e) {
      var _this6 = this;
      this.preloadAllImages();
      (0, _userflow.unlessLocked)(this, e, function () {
        return _this6.scrollMouse(e);
      });
    }
  }, {
    key: "initialImagesCount",
    get: function get() {
      var paginationSize = this.props.paginationSize;
      return paginationSize;
    }
  }, {
    key: "currentImagesCount",
    get: function get() {
      var preloadedItemsCount = this.state.preloadedItemsCount;
      return preloadedItemsCount;
    }
  }, {
    key: "totalImagesCount",
    get: function get() {
      var items = this.props.items;
      return items.length;
    }
  }, {
    key: "topScrollable",
    get: function get() {
      var images = this.topImages;
      return images.querySelector('ul');
    }
  }, {
    key: "bottomScrollable",
    get: function get() {
      var images = this.bottomImages;
      return images.querySelector('ul');
    }
  }, {
    key: "topClientWidth",
    get: function get() {
      return this.topScrollable.clientWidth;
    }
  }, {
    key: "overlayWidth",
    get: function get() {
      return this.topClientWidth / COEFF;
    }
  }, {
    key: "topScrollableWidth",
    get: function get() {
      return this.bottomScrollable.scrollWidth * COEFF - this.topClientWidth;
    }
  }, {
    key: "loaded",
    get: function get() {
      return this.progress >= 100;
    }
  }, {
    key: "progress",
    get: function get() {
      var imageLoadedCount = this.state.imageLoadedCount;
      return Math.round(imageLoadedCount / this.initialImagesCount * 100);
    }
  }, {
    key: "getImageHandlers",
    value: function getImageHandlers(imagesType) {
      var openFullscreen = this.props.openFullscreen;
      for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
      }
      switch (imagesType) {
        case _userflow.IMAGES_TYPE.BIG:
          return openFullscreen ? this.getTopImageHandlers.apply(this, props) : null;
        case _userflow.IMAGES_TYPE.SMALL:
          return this.getBottomImageHandlers.apply(this, props);
        default:
          return null;
      }
    }
  }, {
    key: "getTopImageHandlers",
    value: function getTopImageHandlers(key, origin, i) {
      return (0, _defineProperty2["default"])({}, this.events.get('click'), this.onTopImageClick.bind(this, origin, i));
    }
  }, {
    key: "getBottomImageHandlers",
    value: function getBottomImageHandlers(key, origin, i) {
      return (0, _defineProperty2["default"])({}, this.events.get('click'), this.onBottomImageClick.bind(this, i));
    }
  }, {
    key: "getOverlayStyle",
    value: function getOverlayStyle() {
      var scroll = this.scrollPercentage || 0;
      var offset = (this.bottomScrollable.clientWidth - this.overlayWidth) * (scroll / 100);
      return {
        width: this.overlayWidth,
        left: Number.isNaN(offset) ? 0 : offset
      };
    }
  }, {
    key: "config",
    get: function get() {
      return (this.state || {}).config || {};
    }
  }, {
    key: "containerHeight",
    get: function get() {
      var _this$props = this.props,
        imageHeight = _this$props.imageHeight,
        thumbHeight = _this$props.thumbHeight,
        thumbs = _this$props.thumbs;
      return thumbs ? imageHeight + thumbHeight : imageHeight;
    }
  }, {
    key: "setControlsVisibility",
    value: function setControlsVisibility() {
      var hideControl = null;
      if (this.scrollPercentage === 0) {
        hideControl = 'prev';
      } else if (Math.round(this.scrollPercentage) === 100) {
        hideControl = 'next';
      }
      this.setState({
        hideControl: hideControl
      });
    }
  }, {
    key: "preloadImagesBatch",
    value: function preloadImagesBatch() {
      var _this7 = this;
      this.setState(function (prevState, props) {
        return {
          preloadedItemsCount: Math.min(prevState.preloadedItemsCount + props.paginationSize, _this7.totalImagesCount)
        };
      });
    }
  }, {
    key: "preloadAllImages",
    value: function preloadAllImages() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return null;
      };
      this.setState({
        preloadedItemsCount: this.totalImagesCount
      }, callback);
    }
  }, {
    key: "syncScroll",
    value: function syncScroll(node, opposite) {
      var loaded = this.loaded;
      if (loaded && node) {
        var scrollable = this.topScrollable;
        var scroll = scrollable.scrollLeft;
        var overallPercentage = scroll / this.topScrollableWidth * 100;
        if (this.topScrollableWidth > 0 && this.scrollPercentage !== overallPercentage) {
          if (opposite) {
            ScrollCarousel.scrollNode(opposite, overallPercentage);
          }
          this.scrollPercentage = overallPercentage;
          this.updateScrollableElements();
        }
        var currentScrollWidth = ScrollCarousel.scrollableWidth(scrollable, true);
        var currentPercentage = scroll / currentScrollWidth * 100;
        if (currentScrollWidth > 0 && currentPercentage > PAGINATION_THRESHOLD) {
          this.preloadImagesBatch();
        }
      }
    }
  }, {
    key: "updateScrollableElements",
    value: function updateScrollableElements() {
      if (this.overlay) {
        var overlayStyle = this.getOverlayStyle();
        this.overlay.style.left = "".concat(overlayStyle.left, "px");
      }
      this.setControlsVisibility();
    }

    /**
     * Public method
     * @param {number} index
     */
  }, {
    key: "scrollTo",
    value: function scrollTo(index) {
      var tg = this["topImages-".concat(index)];
      var images = this.topImages;
      var scrollable = images.querySelector('ul');
      var width = tg.clientWidth;
      var offset = tg.offsetLeft - scrollable.scrollLeft + width / 2;
      var offsetDiff = offset - images.clientWidth / 2;
      this.diffScroll(images, offsetDiff, this.bottomImages, true);
    }
  }, {
    key: "scrollMouse",
    value: function scrollMouse(evt) {
      var _this8 = this;
      var overlay = this.overlay;
      var images = this.bottomImages;
      var overlayOffset = ScrollCarousel.offset(overlay);
      var rootOffset = ScrollCarousel.offset(images).left;
      var maxScroll = images.clientWidth - overlay.clientWidth;
      var mouse = ScrollCarousel.cursorPosition(evt.nativeEvent).clientX - rootOffset;
      var handleMove = function handleMove(e) {
        var mouseMovement = ScrollCarousel.cursorPosition(e).clientX - rootOffset;
        var diff = mouseMovement - mouse;
        var offset = overlayOffset.left - rootOffset + diff;
        var percentage = Math.max(0, Math.min(100, offset / maxScroll * 100));
        ScrollCarousel.scrollNode(_this8.topImages, percentage);
        ScrollCarousel.scrollNode(_this8.bottomImages, percentage);
        _this8.scrollPercentage = percentage;
        _this8.updateScrollableElements();
      };
      var isMouseEvent = evt.type === 'mousedown';
      var mousemove = isMouseEvent ? 'mousemove' : 'touchmove';
      var mouseup = isMouseEvent ? 'mouseup' : 'touchend';
      var handleUp = function handleUp() {
        document.removeEventListener(mousemove, handleMove);
        document.removeEventListener(mouseup, handleUp);
      };
      document.addEventListener(mousemove, handleMove);
      document.addEventListener(mouseup, handleUp);
    }
  }, {
    key: "wheelDelta",
    value: function wheelDelta(evt) {
      var xDelta = 0;
      var yDelta = 0;
      if ((0, _userflow.isTouchDevice)()) {
        var _ScrollCarousel$curso = ScrollCarousel.cursorPosition(evt),
          clientX = _ScrollCarousel$curso.clientX,
          clientY = _ScrollCarousel$curso.clientY;
        xDelta = clientX - (this.prevX || 0);
        yDelta = clientY - (this.prevY || 0);
        var _ref5 = [clientX, clientY];
        this.prevX = _ref5[0];
        this.prevY = _ref5[1];
      } else {
        xDelta = evt.wheelDeltaX || evt.deltaX;
        yDelta = evt.wheelDeltaY || evt.deltaY;
      }
      return {
        x: xDelta,
        y: yDelta
      };
    }
  }, {
    key: "diffScroll",
    value: function diffScroll(node, diff) {
      var _this9 = this;
      var sync = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var animate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var scrollable = node.querySelector('ul');
      var _this$props2 = this.props,
        duration = _this$props2.duration,
        easing = _this$props2.easing;
      var initialValue = scrollable.scrollLeft;
      var synchronize = function synchronize() {
        return _this9.syncScroll(node, sync);
      };
      if (animate) {
        this.animate(duration, easing, diff, function (d) {
          scrollable.scrollLeft += Math.round(d);
          synchronize();
        }, function () {
          scrollable.scrollLeft = initialValue + diff;
          synchronize();
        });
      } else {
        scrollable.scrollLeft += diff;
        synchronize();
      }
    }
  }, {
    key: "animate",
    value: function animate(duration, easing, value, clb, endClb) {
      _easing["default"].ease({
        easing: easing,
        duration: duration,
        length: value,
        animate: clb.bind(this),
        end: endClb instanceof Function ? endClb.bind(this) : null
      });
    }

    // OBSERVERS
  }, {
    key: "widthObserver",
    value: function widthObserver() {
      var current = this.containerRef.current;
      if (this.mounted && current) {
        var width = current.clientWidth;
        if (width !== this.width) {
          this.width = width;
          this.syncScroll(this.topImages, this.bottomImages);
        }
      }
      window.requestAnimationFrame(this.widthObserver.bind(this));
    }

    // EVENT HANDLERS
  }, {
    key: "syncScrollHandler",
    value: function syncScrollHandler(refName, oppositeRefName, e) {
      var delta = this.wheelDelta(e.nativeEvent);
      if (delta.x < 0 && delta.x < delta.y || delta.x > 0 && delta.x > delta.y) {
        var node = this[refName];
        var opposite = this[oppositeRefName];
        this.syncScroll(node, opposite);
      }
    }

    // RENDERERS
  }, {
    key: "renderImagesMap",
    value: function renderImagesMap(imagesType, images, config, children) {
      var _this10 = this;
      var openFullscreen = this.props.openFullscreen;
      return images.map(function (item, i) {
        var _item$images = item.images,
          thumbImage = _item$images.thumbImage,
          thumbImageX2 = _item$images.thumbImageX2,
          smallImage = _item$images.smallImage,
          special = item.special;
        var gap = ScrollCarousel.getImageGap(i, images.length, config.gap);
        var handlers = _this10.getImageHandlers(imagesType, thumbImage, item, i);
        var _special$extra = special.extra,
          _special$extra2 = _special$extra === void 0 ? {} : _special$extra,
          isVideo = _special$extra2.is_video;
        var styles = _objectSpread(_objectSpread({}, gap), {}, {
          height: config.height
        });
        var isSmall = imagesType === _userflow.IMAGES_TYPE.SMALL;
        var clickable = isSmall || imagesType === _userflow.IMAGES_TYPE.BIG && openFullscreen;
        var srcSet = !isSmall && thumbImageX2 ? "".concat((0, _userflow.getFullUrl)(thumbImage), " 1x, ").concat((0, _userflow.getFullUrl)(thumbImageX2), " 2x") : undefined;
        var src = isSmall ? (0, _userflow.getFullUrl)(smallImage || thumbImage) : (0, _userflow.getFullUrl)(thumbImage);
        var props = {
          src: src,
          srcSet: srcSet,
          styles: styles
        };
        var loadHandler = isSmall ? _this10.handleThumbLoad : _this10.handleImageLoad;
        return /*#__PURE__*/_react["default"].createElement(StyledImagesItem, (0, _extends2["default"])({
          style: styles,
          key: thumbImage,
          ref: function ref(_ref6) {
            _this10["".concat(imagesType, "-").concat(i)] = _ref6;
          }
        }, handlers), children instanceof Function ? children() : null, /*#__PURE__*/_react["default"].createElement(StyledImagesItemWrapper, null, isVideo && imagesType === _userflow.IMAGES_TYPE.BIG && /*#__PURE__*/_react["default"].createElement(StyledTriangleWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledTriangle, null)), /*#__PURE__*/_react["default"].createElement(StyledImagesItemImg, (0, _extends2["default"])({
          clickable: clickable,
          draggable: "false",
          alt: "",
          onLoad: loadHandler,
          elementType: "img",
          showThrobber: true,
          isThumb: isSmall
        }, props))));
      });
    }
  }, {
    key: "renderTopImages",
    value: function renderTopImages() {
      var _this$props3 = this.props,
        imageHeight = _this$props3.imageHeight,
        gap = _this$props3.gap,
        items = _this$props3.items;
      var preloadedItemsCount = this.state.preloadedItemsCount;
      var imagesType = _userflow.IMAGES_TYPE.BIG;
      var handler = this.syncScrollHandler.bind(this, imagesType, _userflow.IMAGES_TYPE.SMALL);
      var handleScroll = (0, _defineProperty2["default"])({}, this.events.get('wheel'), handler);
      var imagesMap = this.renderImagesMapMemoized(imagesType, items.slice(0, preloadedItemsCount), {
        gap: gap,
        height: imageHeight
      });
      return /*#__PURE__*/_react["default"].createElement(TopImages, {
        ref: this.topImagesRef,
        handleScroll: handleScroll,
        imageHeight: imageHeight,
        preloadedItemsCount: preloadedItemsCount
      }, imagesMap);
    }
  }, {
    key: "renderBottomImages",
    value: function renderBottomImages() {
      var _this$props4 = this.props,
        thumbHeight = _this$props4.thumbHeight,
        thumbGap = _this$props4.thumbGap,
        items = _this$props4.items;
      var imagesMap = this.renderImagesMapMemoized(_userflow.IMAGES_TYPE.SMALL, items, {
        gap: thumbGap,
        height: thumbHeight
      });
      return /*#__PURE__*/_react["default"].createElement(StyledImagesWrapper, {
        style: {
          height: thumbHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(StyledImagesRoot, {
        ref: this.bottomImagesRef
      }, this.renderImagesOverlay(), /*#__PURE__*/_react["default"].createElement(StyledImagesScrollable, {
        style: {
          overflow: 'hidden'
        }
      }, imagesMap)));
    }
  }, {
    key: "renderImagesOverlay",
    value: function renderImagesOverlay() {
      var _this11 = this;
      var images = this.bottomImages;
      if (images) {
        if (this.topClientWidth < this.topScrollableWidth) {
          var handler = (0, _defineProperty2["default"])({}, this.events.get('mousedown'), this.onOverlayDown.bind(this));
          var initialStyle = this.getOverlayStyle();
          return /*#__PURE__*/_react["default"].createElement(StyledImagesOverlay, (0, _extends2["default"])({
            ref: function ref(overlay) {
              _this11.overlay = overlay;
            },
            style: initialStyle
          }, handler));
        }
        return null;
      }
      return null;
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var hideControl = this.state.hideControl;
      var imageHeight = this.props.imageHeight;
      var attrs = (0, _defineProperty2["default"])({
        style: {
          height: imageHeight
        }
      }, this.events.get('click'), this.onArrowClick);
      return /*#__PURE__*/_react["default"].createElement(StyledControls, null, hideControl !== 'prev' && /*#__PURE__*/_react["default"].createElement(StyledControlsButton, (0, _extends2["default"])({}, attrs, {
        "data-direction": -1
      }), /*#__PURE__*/_react["default"].createElement(ArrowIcon, null)), hideControl !== 'next' && /*#__PURE__*/_react["default"].createElement(StyledControlsButton, (0, _extends2["default"])({}, attrs, {
        "data-direction": 1
      }), /*#__PURE__*/_react["default"].createElement(ArrowIcon, null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        className = _this$props5.className,
        thumbs = _this$props5.thumbs,
        controls = _this$props5.controls;
      var progress = this.progress,
        loaded = this.loaded;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
        ref: this.containerRef,
        className: className,
        height: this.containerHeight
      }, !loaded && /*#__PURE__*/_react["default"].createElement(StyledProgressBar, {
        value: progress
      }), /*#__PURE__*/_react["default"].createElement(StyledScrollGallery, {
        style: {
          opacity: loaded ? 1 : 0
        }
      }, loaded && controls && this.renderControls(), this.renderTopImages(), thumbs && this.renderBottomImages()));
    }
  }], [{
    key: "cursorPosition",
    value: function cursorPosition(evt) {
      var clientX = evt.clientX,
        clientY = evt.clientY;
      if (evt.touches) {
        clientX = evt.touches[0].clientX;
        clientY = evt.touches[0].clientY;
      }
      return {
        clientX: clientX,
        clientY: clientY
      };
    }
  }, {
    key: "scrollableWidth",
    value: function scrollableWidth(scrollable) {
      var full = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var nScrollable = scrollable;
      var node = nScrollable.parentNode;
      if (nScrollable.nodeName !== 'UL') {
        node = nScrollable;
        nScrollable = node.querySelector('ul');
      }
      var _nScrollable = nScrollable,
        scrollWidth = _nScrollable.scrollWidth;
      if (full) {
        return scrollWidth - node.clientWidth;
      }
      return scrollWidth;
    }
  }, {
    key: "offset",
    value: function offset(elem) {
      var nElem = elem;
      var left = 0;
      var top = 0;
      do {
        if (!Number.isNaN(nElem.offsetLeft)) {
          left += nElem.offsetLeft;
          top += nElem.offsetTop;
        }
        nElem = nElem.offsetParent;
      } while (nElem);
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "getImageGap",
    value: function getImageGap(i, count, gap) {
      var nGap = Math.floor(gap / 2) * 2;
      if (i === 0) {
        return {
          marginRight: nGap
        };
      }
      if (i < count - 1) {
        return {
          marginRight: nGap,
          marginLeft: nGap
        };
      }
      return {
        marginLeft: nGap
      };
    }
  }, {
    key: "scrollNode",
    value: function scrollNode(node, percent) {
      var scrollable = node.querySelector('ul');
      if (scrollable.scrollWidth !== scrollable.clientWidth) {
        var scrollWidth = ScrollCarousel.scrollableWidth(scrollable, true);
        scrollable.scrollLeft = percent * (scrollWidth / 100);
      }
    }
  }]);
}(_react["default"].PureComponent);
ScrollCarousel.propTypes = {
  className: _propTypes["default"].string,
  height: _propTypes["default"].number,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    images: _propTypes["default"].shape((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _userflow.IMAGES_SIZE.SMALL, _propTypes["default"].string), _userflow.IMAGES_SIZE.FULL, _propTypes["default"].string), _userflow.IMAGES_SIZE.BIG, _propTypes["default"].string.isRequired), _userflow.IMAGES_SIZE.BIG_X2, _propTypes["default"].string)).isRequired,
    special: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      content: _propTypes["default"].string,
      title: _propTypes["default"].string
    }).isRequired
  })),
  paginationSize: _propTypes["default"].number,
  controls: _propTypes["default"].bool,
  thumbs: _propTypes["default"].bool,
  onImageClick: _propTypes["default"].func,
  imageHeight: _propTypes["default"].number,
  thumbHeight: _propTypes["default"].number,
  gap: _propTypes["default"].number,
  thumbGap: _propTypes["default"].number,
  openFullscreen: _propTypes["default"].bool,
  duration: _propTypes["default"].number,
  easing: _propTypes["default"].string
};
ScrollCarousel.defaultProps = {
  className: '',
  height: 350,
  items: [],
  paginationSize: null,
  controls: false,
  thumbs: false,
  onImageClick: Function.prototype,
  imageHeight: 300,
  thumbHeight: 40,
  gap: 0,
  thumbGap: 0,
  openFullscreen: false,
  duration: 600,
  easing: 'easeInOutQuad'
};
var TopImagesComponent = function TopImagesComponent(props, ref) {
  var imageHeight = props.imageHeight,
    handleScroll = props.handleScroll,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledImagesWrapper, {
    style: {
      height: imageHeight
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledImagesRoot, (0, _extends2["default"])({}, handleScroll, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(StyledImagesScrollable, null, children)));
};
var TopImages = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(TopImagesComponent), function (prevProps, nextProps) {
  return (prevProps.children === nextProps.children || prevProps.imageHeight === nextProps.imageHeight) && prevProps.preloadedItemsCount === nextProps.preloadedItemsCount;
});
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledContainer",
  componentId: "sc-1dsdxgg-0"
})(["z-index:1;height:", "px;width:100%;overflow:hidden;user-select:none;position:relative;"], function (props) {
  return props.height;
});
var StyledScrollGallery = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledScrollGallery",
  componentId: "sc-1dsdxgg-1"
})(["transition:opacity 120ms ease;"]);
var StyledImagesWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledImagesWrapper",
  componentId: "sc-1dsdxgg-2"
})(["text-align:center;"]);
var StyledImagesRoot = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledImagesRoot",
  componentId: "sc-1dsdxgg-3"
})(["height:100%;display:inline-block;max-width:100%;overflow:hidden;position:relative;vertical-align:top;white-space:nowrap;"]);
var StyledImagesOverlay = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledImagesOverlay",
  componentId: "sc-1dsdxgg-4"
})(["box-sizing:border-box;top:0;bottom:0;left:0;z-index:10;width:300px;cursor:col-resize;position:absolute;border:2px solid ", ";box-shadow:0 0 0 99999px rgba(255,255,255,0.5);"], function (props) {
  return props.theme.colors.yellowBase;
});
var StyledImagesScrollable = _styledComponents["default"].ul.withConfig({
  displayName: "ScrollCarousel__StyledImagesScrollable",
  componentId: "sc-1dsdxgg-5"
})(["margin:0;overflow-x:auto;overflow-y:hidden;text-align:center;position:relative;padding:0 0 30px 0;box-sizing:content-box;"]);
var StyledImagesItem = _styledComponents["default"].li.withConfig({
  displayName: "ScrollCarousel__StyledImagesItem",
  componentId: "sc-1dsdxgg-6"
})(["padding:0;height:100%;line-height:0;overflow:hidden;position:relative;white-space:nowrap;vertical-align:top;list-style-type:none;display:inline-block;box-sizing:content-box;"]);
var StyledImagesItemWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledImagesItemWrapper",
  componentId: "sc-1dsdxgg-7"
})(["width:100%;height:100%;position:relative;transition:scale 100ms ease,opacity 100ms ease;", " @keyframes spin{0%{transform:scale(0.98) rotate(0deg);}100%{transform:scale(0.98) rotate(360deg);}}"], function (props) {
  return props.loading && "\n    opacity: 0.9;\n    pointer-events: none;\n    transform: scale(1.02);\n\n    ::after {\n      right: 11px;\n      bottom: 8px;\n      width: 14px;\n      content: '';\n      height: 14px;\n      display: block;\n      position: absolute;\n      border-radius: 100%;\n      border: 2px solid #fff;\n      border-right-color: rgba(255, 255, 255, 0.5);\n      border-bottom-color: rgba(255, 255, 255, 0.5);\n      animation: spin 1s -1s linear infinite;\n    }\n\n    img {\n      filter: blur(3px);\n    }\n  ";
});
var StyledImagesItemImg = (0, _styledComponents["default"])(_PreloadImage["default"]).withConfig({
  displayName: "ScrollCarousel__StyledImagesItemImg",
  componentId: "sc-1dsdxgg-8"
})(["margin:0;padding:0;min-width:", "px;height:100%;display:block;box-sizing:content-box;transition:filter 100ms ease;", ""], function (_ref7) {
  var isThumb = _ref7.isThumb;
  return isThumb ? 0 : 190;
}, function (props) {
  return props.clickable && "\n    cursor: pointer;\n  ";
});
var StyledTriangleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledTriangleWrapper",
  componentId: "sc-1dsdxgg-9"
})(["position:absolute;width:100%;height:100%;z-index:2;display:flex;justify-content:center;align-items:center;cursor:pointer;"]);
var StyledTriangle = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledTriangle",
  componentId: "sc-1dsdxgg-10"
})(["width:0;height:0;border-style:solid;border-width:31px 0 31px 38px;border-color:transparent transparent transparent #ffffff;"]);

// controls

var StyledControls = _styledComponents["default"].div.withConfig({
  displayName: "ScrollCarousel__StyledControls",
  componentId: "sc-1dsdxgg-11"
})(["z-index:20;width:100%;height:0px;position:relative;"]);
var StyledControlsButton = _styledComponents["default"].button.withConfig({
  displayName: "ScrollCarousel__StyledControlsButton",
  componentId: "sc-1dsdxgg-12"
})(["top:0;margin:0;padding:0;width:50px;outline:none;border:none;cursor:pointer;background:none;text-align:center;position:absolute;display:table-cell;vertical-align:middle;opacity:0.5;transition:opacity 120ms ease;:hover{opacity:1;}", ";"], function (props) {
  return "\n    ".concat(props['data-direction'] < 0 ? "\n      left: 0;\n      transform: rotate(180deg);\n    " : "\n      right: 0;\n    ", ";\n  ");
});
var StyledProgressBar = (0, _styledComponents["default"])(_ProgressBar["default"]).withConfig({
  displayName: "ScrollCarousel__StyledProgressBar",
  componentId: "sc-1dsdxgg-13"
})(["position:absolute;left:0;top:0;bottom:0;right:0;"]);
var _default = exports["default"] = ScrollCarousel;